const ClientData01 = [
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
];

const ClientData02 = [
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
];

const ClientData03 = [
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
];

const ClientData04 = [
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
];

const ClientData05 = [
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
];

const ClientData06 = [
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
];

const ClientData07 = [
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
  {
    img: "/assets/img/webp/transparent.webp",
    target: "_self",
    link: "#",
  },
];

const ClientData08 = [
  {
    img: "/assets/img/webp/transparent.webp",
  },
  {
    img: "/assets/img/webp/transparent.webp",
  },
  {
    img: "/assets/img/webp/transparent.webp",
  },
  {
    img: "/assets/img/webp/transparent.webp",
  },
];

export {
  ClientData01,
  ClientData02,
  ClientData03,
  ClientData04,
  ClientData05,
  ClientData06,
  ClientData07,
  ClientData08,
};
